module.exports = __webpack_public_path__ + "static/img/discount-coupon.6ba3e331.png";